module.exports = __webpack_public_path__ + "img/Python.2abc28b9.png";